import {REDUCED_MOTION_QUERY} from '@AiChat/hooks/usePopupExpandAnimation.types';

export const isAiChatMotionReduced = (): boolean => {
  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
};

export const getAiChatMotionDurationMs = (durationMs: number): number => {
  if (isAiChatMotionReduced()) {
    return 0;
  }

  return durationMs;
};
